import service from "services/service";

export const getYesterdayConcilliations = () => (
  service('get', `v3/conciliacion/ayer`)
)
export const retrySingleConcilliation = (data) => (
  service('post', `v3/conciliacion/reintentar`, { data })
)
export const retryMultipleConcilliation = (data) => (
  service('post', `v3/conciliacion/reintentar/multiple`, { data })
)


